import { getGridStringOperators } from "@mui/x-data-grid";
import moment from "moment";
import { Link } from "react-router-dom";

export const meetingsColumns = [
  { field: "id", headerName: "ID", width: 95 },
  {
    field: "topic",
    headerName: "Topic",
    minWidth: 330,
    flex: 1,
    renderCell: (params: any) => {
      const onClickEdit = (e: any) => {
        e.stopPropagation(); // don't select this row after clicking
      };
      return (
        <Link to={`/meetings/${params.id}`}>
          <p>{params.row.topic}</p>
        </Link>
      );
    },
    valueGetter: (params: any) => {
        return params.row.topic;
    },
  },
  {
    field: "start_time",
    headerName: "Start Time",
    type: "string",
    minWidth: 150,
    flex: 1,
    renderCell: (params: any) => {
      return moment(params.row.start_time).utc().format("HH:mm DD-MM-YYYY");
    },
  },
  {
    field: "groups",
    headerName: "Groups",
    type: "string",
    minWidth: 150,
    flex: 1,
    renderCell: (params: any) => {
      const onClickEdit = (e: any) => {
        e.stopPropagation(); // don't select this row after clicking
      };

      if (!params.row.groups || params.row.groups === null || params.row.groups.length === 0) {
        return null;
      } else if (params.row.groups.length === 1) {
        return params.row.groups[0]?.name;
      } else {
        const arr = Object.values(params.row.groups);

        const numOfGroups = arr.length;

        const arrNew = [];
        for (let i = 0; i < numOfGroups; i++) {
          arrNew.push(params.row.groups[i]?.name);
        }

        return (
          <div>
            <select
              style={{ width: `${70}px` }}
              defaultValue={numOfGroups}
              placeholder={String(numOfGroups)}
              onClick={onClickEdit}
            >
              <option disabled hidden>
                {numOfGroups}
              </option>
              {arrNew.map((value, index) => (
                <option disabled key={index} value={value}>
                  {value}
                </option>
              ))}
            </select>
          </div>
        );
      }
    },
    valueGetter: (params: any) => {
      if (!params.row.groups || params.row.groups === null || params.row.groups.length === 0) {
        return null;
      } else if (params.row.groups.length === 1) {
        return params.row.groups[0]?.name;
      } else {
        const arrOfGroups = Object.values(params.row.groups);

        const numOfGroups = arrOfGroups.length;

        let strNew = "";
        for (let i = 0; i < numOfGroups; i++) {
          strNew += ` ${params.row.groups[i]?.name}`;
        }

        return strNew;
      }
    },
    sortComparator: (v1: any, v2: any, sort: any) => {
      if (v1 === null && v2 === null) return 0;
      else if (v1 === null) return 1;
      else if (v2 === null) return -1;
      else return `${v1}`.localeCompare(`${v2}`);
    },
    filterOperators: getGridStringOperators().filter(
      (operator) =>
        operator.value === "contains" ||
        operator.value === "isEmpty" ||
        operator.value === "isNotEmpty",
    ),
  },
  {
    field: "action",
    headerName: "Action",
    minWidth: 200,
    flex: 1,
    sortable: false,
    filterable: false,
    renderCell: (params: any) => {
      return (
        <Link to={`/meetings/${params.id}`}>
          <button className="btn-primary-fill bg-blue">{"Open"}</button>
        </Link>
      );
    },
  },
];
